var render = function render(){var _vm=this,_c=_vm._self._c;return _c('upstream-sewage-wizard',{attrs:{"tool-name":"Outpouring","title-translation-path":"sidebar.upstreamSewage.outpouringTitle"}})
}
var staticRenderFns = []

export { render, staticRenderFns }